import { PREVIEW_STATUS } from 'constants/constant';
import { filterUnselectedItems } from 'helper/utils';
import actionTypes from 'redux/actionTypes';

const initialState = {
	selectedList: [],
	previewLoading: false,
	previewData: { jsonResponse: [] },
	previewErrorCode: PREVIEW_STATUS.NO_ERROR,
	rowCount: undefined,
	selectedListCount: 0,
	filterList: [],
	prevSelectedList: [],
	prevFilterList: [],
	uuid: undefined,
	isPreviewLoaded: false,
	rowCountRequest: {},
	menu: undefined,
	editData: {},
	rowCountErrorCode: 0,
	isDimFilterMandate: false,
	isCalFilterApplied: false,
	linkItemActivity: '',
	hierarchy: [],
	draftName: 'Untitled',
	draftErrorCode: 0,
	draftId: null,
	draftFilterList: [],
	draftSelectedList: [],
	isDraftSaved: false,
	itemShareStatus: { prev: false, curr: false },
	mandatorySelection: [],
	pinnedAttribute: {
		showSnackbar: false
	},
	isMtsFilterCollapsed: false,
	pivotOpts: {
		showPopup: false,
		pivotColumn: null,
		isMultiWeek: false,
		isTimeAcross: false
	},
	draftPivotColumn: null,
	visualHierarchyList: []
};

const previewReducer = (state = initialState, action = {}) => {
	switch (action.type) {
		case actionTypes.SET_SELECTED_LIST:
			return {
				...state,
				selectedList: action.payload,
				previewErrorCode: PREVIEW_STATUS.NO_ERROR,
				isPreviewLoaded: false
			};
		case actionTypes.SET_FILTER_LIST:
			return {
				...state,
				filterList: action.payload,
				previewErrorCode: PREVIEW_STATUS.NO_ERROR,
				isPreviewLoaded: false
			};
		case actionTypes.CLEAR_UNSELECTED_ITEMS_FILTERS: {
			const updatedFilterList = filterUnselectedItems(
				state.filterList,
				state.selectedList,
				action.payload
			);
			return {
				...state,
				filterList: updatedFilterList
			};
		}
		case actionTypes.SET_PREV_SELECTED_LIST:
			return {
				...state,
				prevSelectedList: action.payload
			};
		case actionTypes.SET_PREV_FILTER_LIST:
			return {
				...state,
				prevFilterList: action.payload
			};
		case actionTypes.DRAFT_PREV_SELECTED_LIST:
			return {
				...state,
				draftSelectedList: action.payload
			};
		case actionTypes.DRAFT_PREV_FILTER_LIST:
			return {
				...state,
				draftFilterList: action.payload
			};
		case actionTypes.DRAFT_PREV_PIVOT_OPTION:
			return {
				...state,
				draftPivotColumn: action.payload
			};
		case actionTypes.LOAD_PREVIEW_PAGE:
			return {
				...state,
				previewLoading: true,
				selectedListCount: action.payload.requestBody?.fields.length,
				isPreviewLoaded: false,
				editData: action.payload.editData,
				draftName: action.payload.editData.reportName,
				draftId: action.payload.editData.reportId,
				isDraftSaved: true
			};
		case actionTypes.LOAD_PREVIEW_DATA:
			return {
				...state,
				selectedListCount: action.payload.requestBody?.fields.length,
				editData: action.payload.editData,
				draftName: action.payload.editData.reportName,
				draftId: action.payload.editData.reportId,
				isDraftSaved: true,
				linkItemActivity: action.payload.editData.linkItemActivity,
				pivotOpts: {
					...state.pivotOpts,
					pivotColumn: action.payload.editData?.pivotColumn,
					isTimeAcross: Boolean(action.payload.editData?.isTimeAcrossDataDown)
				}
			};
		case actionTypes.GET_PREVIEW: {
			return {
				...state,
				previewLoading: true,
				selectedListCount: action.payload.requestBody?.fields.length,
				isPreviewLoaded: false,
				editData: action.payload.editData // this can be removed.
			};
		}
		case actionTypes.GET_PREVIEW_SUCCESS:
			return {
				...state,
				previewData: action.payload,
				previewLoading: false,
				previewErrorCode: PREVIEW_STATUS.NO_ERROR,
				isPreviewLoaded: true
			};
		case actionTypes.GET_PREVIEW_FAILURE:
			return {
				...state,
				previewData: { jsonResponse: [] },
				previewLoading: false,
				previewErrorCode: action.payload,
				isPreviewLoaded: false
			};
		case actionTypes.CLEAR_PREVIEW:
			return {
				...state,
				previewData: { jsonResponse: [] },
				previewLoading: false,
				linkItemActivity: ''
			};
		case actionTypes.CLEAR_PREV_SELECTION:
			return {
				...state,
				prevFilterList: [],
				prevSelectedList: []
			};

		case actionTypes.REMOVE_PREVIEW_COLUMN: {
			return {
				...state,
				previewData: action.payload
			};
		}
		case actionTypes.ADD_PREVIEW_COLUMN: {
			return {
				...state,
				previewData: action.payload
			};
		}
		case actionTypes.GET_ROW_COUNT: {
			return {
				...state,
				rowCount: undefined,
				selectedListCount: action.payload.requestBody?.fields?.length,
				rowCountRequest: action.payload.requestBody,
				uuid: undefined,
				rowCountErrorCode: 0
			};
		}
		case actionTypes.GET_ROW_COUNT_SUCCESS:
			return {
				...state,
				rowCount: action.payload.rowCount,
				uuid: action.payload.sqlString,
				rowCountErrorCode: 0
			};
		case actionTypes.GET_ROW_COUNT_FAILURE:
			return {
				...state,
				rowCount: undefined,
				uuid: undefined,
				rowCountErrorCode: action.payload
			};
		case actionTypes.CLEAR_PREVIEWED_LOADED:
			return {
				...state,
				previewErrorCode: PREVIEW_STATUS.NO_ERROR,
				isPreviewLoaded: false
			};
		case actionTypes.SET_MENU:
			return {
				...state,
				menu: action.payload
			};
		case actionTypes.SET_IS_MANDATE_CHECK:
			return {
				...state,
				isDimFilterMandate: action.payload
			};

		case actionTypes.SET_REQUIRED_CHECK:
			return {
				...state,
				isCalFilterApplied: action.payload
			};
		case actionTypes.SET_LINK_ITEMS_ACTIVITY:
			return {
				...state,
				linkItemActivity: action.payload
			};
		case actionTypes.SET_HIERARCHY:
			return {
				...state,
				hierarchy: action.payload
			};
		case actionTypes.SAVE_DRAFT:
		case actionTypes.RESET_SAVED_DRAFT_STATUS:
			return {
				...state,
				isDraftSaved: false
			};
		case actionTypes.SAVE_DRAFT_SUCCESS:
			return {
				...state,
				draftName: action.payload.draftName,
				draftId: action.payload.draftId,
				draftErrorCode: 0,
				isDraftSaved: true
			};
		case actionTypes.SAVE_DRAFT_FAILURE:
			return {
				...state,
				draftErrorCode: action.payload,
				isDraftSaved: false
			};
		case actionTypes.RESET_DRAFT:
			return {
				...state,
				draftId: null,
				draftName: 'Untitled',
				isDraftSaved: false,
				draftSelectedList: [],
				draftFilterList: []
			};
		case actionTypes.RESET_ROWCOUNT_OBJ:
			return {
				...state,
				rowCount: undefined,
				selectedListCount: 0,
				rowCountRequest: {},
				uuid: undefined,
				rowCountErrorCode: 0
			};
		case actionTypes.ITEM_SHARED_STATUS:
			return {
				...state,
				itemShareStatus: { ...state.itemShareStatus, ...action.payload }
			};
		case actionTypes.ITEM_SHARE_MANDATORY_SELECTION:
			return {
				...state,
				mandatorySelection: action.payload
			};
		case actionTypes.SET_PINNED_ATTRIBUTE:
			return {
				...state,
				pinnedAttribute: {
					...state.pinnedAttribute,
					[action.payload.templateId]: action.payload.newPinnedAttributes
				}
			};
		case actionTypes.GET_PINNED_ATTRIBUTE_SUCCESS:
			return {
				...state,
				pinnedAttribute: {
					...state.pinnedAttribute,
					[action.payload.templateId]: action.payload.pinnedAttributeList
				}
			};
		case actionTypes.SET_PINNED_ATTRIBUTE_SNACKBAR:
			return {
				...state,
				pinnedAttribute: {
					...state.pinnedAttribute,
					showSnackbar: action.payload
				}
			};
		case actionTypes.SET_IS_MTS_FILTER_COLLAPSED:
			return {
				...state,
				isMtsFilterCollapsed: action.payload
			};
		case actionTypes.SET_PIVOT_OPTS:
			return {
				...state,
				pivotOpts: {
					...state.pivotOpts,
					...action.payload
				}
			};
		case actionTypes.GET_VISUAL_HIERARCHY_SUCCESS:
			return {
				...state,
				visualHierarchyList: [...action.payload]
			};
		case actionTypes.GET_VISUAL_HIERARCHY_FAILURE:
			return {
				...state
			};
		default:
			return state;
	}
};

export default previewReducer;
